import { useState } from "react";
import LeasesTable from "@/modules/Leases/components/LeasesTable";
import { LeaseFilters } from "@/modules/Leases/types/leases.types";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { FileText, PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/shared/PageHeader";
import { LeasesTabProps } from "./LeasesTab";


export const LeasesList = ({ property }: LeasesTabProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [filters, setFilters] = useState<LeaseFilters>({
        propertyUUID: property.propertyUUID,
        page: 0,
        size: 10,
    });

    const handlePageChange = (page: number) => {
        setFilters((prev) => ({
            ...prev,
            page,
        }));
    };

    const handleAddLease = () => {
        navigate(`/home/properties/${property.propertyUUID}/leases/create`);
    };

    return (
        <div className="space-y-6">
            <PageHeader
                icon={<FileText />}
                title={t("leases.title")}
                description={t("leases.description")}
                actions={
                    <Button onClick={handleAddLease}>
                        <PlusCircle className="mr-2 h-4 w-4" />
                        {t("leases.actions.addLease")}
                    </Button>
                }
            />
            <LeasesTable
                filters={filters}
                onPageChange={handlePageChange}
                propertyUUID={property.propertyUUID}
                hidePropertyColumn={true}
            />
        </div>
    );
};
